export const baseUrl = process.env.REACT_APP_BASE_URL;
export const culqiPublicToken = process.env.REACT_APP_CULQI_PUBLIC_TOKEN;
export const culqiPrivateToken = process.env.REACT_APP_CULQI_PRIVATE_TOKEN;
export const apiperuToken = process.env.REACT_APP_APIPERU_TOKEN;
export const captchaToken = process.env.REACT_APP_RECAPTCHA_GOOGLE_TOKEN;
export const geolocationToken = process.env.REACT_APP_GEOLOCATION_TOKEN;

export * from "./main";
export * from "./selection";
